import React from 'react';
import { TermsLayout } from '@meettry/company/component/templates/termsLayout';

const Tokutei: React.FC = () => {
  return <TermsLayout file="tokutei" />;
};

export default Tokutei;
